import { combineReducers, configureStore } from '@reduxjs/toolkit'
import userReducer from './user'
import deUserReducer from './deUser'
import customerSlice from './customer'
import childCustomerSlice from './childCustomer'
import subscriptionSlice from './subscription'
import alertsReducer from './alerts'

import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux'

import { reducer as practiceDEReducer, oshaHippaMiddleware, sraReducer } from '../views/practice/dentalenhancements'
import { shipmentsReducer } from '../views/practice/shipments'
import { setCurrentYear } from '../views/practice/dentalenhancements/slice';
import { tasksReducer } from '../views/practice/tasks';
import { reportsReducer } from '../views/practice/reports/reducer';
import { practiceDashboardReducer } from '../views/practice/dashboard/reducer'

// Create the root reducer separately so we can extract the RootState type
const rootReducer = combineReducers({
  alerts: alertsReducer,
  customer: customerSlice,
  childCustomer: childCustomerSlice,
  currentUser: userReducer,
  deUser: deUserReducer,
  practiceDE: practiceDEReducer,
  sra: sraReducer,
  shipments: shipmentsReducer,
  subscription: subscriptionSlice,
  tasks: tasksReducer,
  reports: reportsReducer,
  practiceDashboard: practiceDashboardReducer,
});

export const setupStore = (preloadedState?: Partial<RootState>) => {
  return configureStore({
    devTools: {
      actionCreators: { setCurrentYear }
    },
    reducer: rootReducer,
    preloadedState,
    middleware: (getDefaultMiddleware) => getDefaultMiddleware().prepend(oshaHippaMiddleware.middleware)
  })
}

export default setupStore()

export type AppStore = ReturnType<typeof setupStore>
export type RootState = ReturnType<typeof rootReducer>
export type AppDispatch = AppStore['dispatch']

export const useAppDispatch: () => AppDispatch = useDispatch
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector
